import translations from "@/shared/translations";
import { useState } from "react";
import { IntlProvider } from "use-intl";
import LanguageProviderContext from "./language/language.context";
import { Language, LanguageProviderProps } from "./language/language.types";

export default function LanguageProvider({
  children,
  defaultLanguage = "en-US",
  storageKey = "vite-ui-language",
  ...props
}: LanguageProviderProps) {
  const [language, setLanguage] = useState<Language>(
    () => (localStorage.getItem(storageKey) as Language) || defaultLanguage
  );

  const value = {
    language,
    setLanguage: (lang: Language) => {
      localStorage.setItem(storageKey, lang);
      setLanguage(lang);
    },
  };

  return (
    <LanguageProviderContext.Provider {...props} value={value}>
      <IntlProvider locale={language} messages={translations[language]}>
        {children}
      </IntlProvider>
    </LanguageProviderContext.Provider>
  );
}
